import { styled } from '@styles/stitches';

export const Container = styled('div', {
  display: 'flex',
  border: '1px solid $colors$primaryBorder',
  borderRadius: 5,
  padding: 8,
  marginBottom: '$space$4',
  justifyContent: 'space-between',
});
